import { DomWorker } from './DomWorker';

export class FooterChildren {
	constructor(content) {
		this.content = content;
	}

	async getColumnItem(item) {
		const { type } = item;
		const footerItem = document.createElement('li');
		if (type === 'link') {
			const linkElement = await DomWorker.getLink(item);
			footerItem.appendChild(linkElement);
		}
		return footerItem;
	}

	async getColumns() {
		const mapColumns = async (column) => {
			return Promise.all(column.map((item) => this.getColumnItem(item))).then(
				(items) => items
			);
		};

		const columns = await Promise.all(this.content.map(mapColumns)).then(
			(columnItems) =>
				columnItems.map((columnItem) => {
					const ulColumn = document.createElement('ul');
					columnItem.forEach((item) => ulColumn.appendChild(item));
					return ulColumn;
				})
		);

		return columns;
	}

	async getFooterContent() {
		const div = document.createElement('div');
		const footerColumns = await this.getColumns();
		footerColumns.forEach((column) => div.appendChild(column));
		return div;
	}
}
